<template>
        <p>
                このサイトはお使いのブラウザー（Internet Explorer）には対応していません。Google Chromeなどをご利用ください。
        </p>
</template>

<script>
    export default {
        name: "Alert"
    }
</script>

<style scoped>
        p {
                margin-top: 30px;
                text-align: center;
                font-size: 20px;
        }
</style>